import React from 'react';
import { Link, browserHistory } from 'react-router';

import { Logo } from 'src/common/components/logo';

import './black-friday-over.css';

const BlackFridayOver = () => {
  return (
    <div className="black-friday-over">
      <div className="container">
        <Link to="/" className="streamable-logo" key="logo">
          <Logo type="black" />
        </Link>
        <div className="message-container">
          <div className="black-friday--title">
            <h2 className="header">
              <span>This offer has expired!</span>
            </h2>
            <div className="underline">
              <svg
                viewBox="0 0 319 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M293.706 1.47692C286.787 1.2 279.748 0.923077 272.71 0.646154C270.443 0.553846 268.057 0.553846 265.791 0.461538C260.78 0.369231 255.77 0.276923 250.759 0.184615C248.016 0.0923077 245.152 0.0923077 242.409 0C241.574 0 240.739 0 240.023 0C238.233 0 236.444 0 234.535 0C226.304 0 218.072 0 209.841 0C207.932 0 205.904 0 203.996 0.0923077C199.104 0.184615 194.333 0.184615 189.441 0.276923C183.954 0.369231 178.466 0.369231 172.979 0.461538C164.151 0.646154 155.204 0.830769 146.376 1.01538C141.246 1.10769 136.116 1.2 130.987 1.29231C122.159 1.56923 113.331 1.84615 104.503 2.12308C99.6118 2.30769 94.84 2.4 89.9489 2.58462C80.7631 3.04615 71.5774 3.41538 62.3916 3.78462C57.5005 3.96923 52.6094 4.15385 47.7182 4.43077C38.6518 4.98462 29.466 5.63077 20.3996 6.27692C18.4908 6.36923 16.4628 6.55385 14.4348 6.64615C10.6173 6.92308 6.68055 7.38462 2.7438 7.75385C2.50521 7.75385 2.26662 7.84615 2.02803 7.84615C1.55084 7.84615 1.19296 8.03077 0.835069 8.30769C0.238591 8.76923 0 9.32308 0 9.87692C0 10.4308 0.238591 10.9846 0.835069 11.3538C1.31225 11.7231 2.14732 12 2.7438 12C7.51562 11.6308 12.1682 11.1692 16.94 10.8C21.3539 10.5231 25.7679 10.2462 30.1818 9.96923C34.9536 9.69231 39.7254 9.32308 44.6166 9.04615C46.5253 8.95385 48.434 8.76923 50.462 8.67692C57.9777 8.4 65.374 8.03077 72.8896 7.75385C77.5422 7.56923 82.1947 7.38461 86.8472 7.2C88.7559 7.10769 90.6647 7.01538 92.5734 6.92308C99.9697 6.64615 107.366 6.46154 114.762 6.18462C119.296 6.09231 123.71 5.90769 128.243 5.81538C129.794 5.81538 131.225 5.72308 132.776 5.72308C140.769 5.53846 148.762 5.44615 156.754 5.26154C161.168 5.16923 165.702 5.07692 170.116 4.98462C171.666 4.98462 173.337 4.89231 174.887 4.89231C183.119 4.8 191.35 4.8 199.701 4.70769C204.831 4.70769 209.96 4.61538 215.09 4.61538C223.799 4.61538 232.626 4.61538 241.335 4.70769C243.005 4.70769 244.795 4.8 246.465 4.8C251.356 4.89231 256.128 4.98462 261.019 5.16923C264.598 5.26154 268.296 5.35385 271.875 5.44615C274.499 5.53846 277.004 5.63077 279.629 5.72308C287.145 6 294.779 6.36923 302.295 6.73846C304.204 6.83077 306.113 6.92308 308.021 7.01538C310.049 7.10769 312.197 7.2 314.225 7.38462C314.583 7.38462 314.821 7.47692 315.179 7.56923C316.014 7.66154 316.73 7.66154 317.446 7.29231C318.161 7.01538 318.639 6.46154 318.877 5.90769C319.354 4.70769 318.4 3.41538 316.73 3.04615C315.298 2.76923 313.867 2.67692 312.555 2.49231C311.6 2.4 310.646 2.30769 309.691 2.30769C307.783 2.12308 305.874 2.12308 304.085 1.93846C300.744 1.84615 297.165 1.66154 293.706 1.47692Z"
                  fill="#378EF8"
                />
              </svg>
            </div>
          </div>

          <div className="black-friday-over--subtitle">
            <p className="black-friday-over--subtitle-reason">
              You missed out on this offer. You can still save big with our
              annual plan discount.
            </p>
          </div>

          <div className="black-friday-over--cta">
            <button
              className="blue-button"
              onClick={() => {
                browserHistory.push(`/upgrade?src_internal=black-friday-over`);
              }}
            >
              Upgrade To Pro
            </button>
          </div>

          <p className="black-friday-over--cancel">Cancel anytime.</p>

          <Link to="/" className="black-friday-over--go-to-dashboard">
            Continue to dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BlackFridayOver;
